const AVATAR_COLORS = [
    'bg-red-500', 'bg-orange-500', 'bg-amber-500', 'bg-yellow-500',
    'bg-lime-500', 'bg-green-500', 'bg-emerald-500', 'bg-teal-500',
    'bg-cyan-500', 'bg-sky-500', 'bg-blue-500', 'bg-indigo-500',
    'bg-violet-500', 'bg-purple-500', 'bg-fuchsia-500', 'bg-pink-500', 'bg-rose-500'
];

function getInitials(name) {
    if (!name || typeof name !== 'string') return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
}

function getAvatarColor(name) {
    if (!name) return AVATAR_COLORS[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function setOpen(root, open) {
    const panel = root.querySelector('[data-auth-avatar-panel]');
    const trigger = root.querySelector('[data-auth-avatar-trigger]');
    const chevron = root.querySelector('[data-auth-avatar-chevron]');
    if (!panel || !trigger) return;

    panel.hidden = !open;
    panel.style.display = open ? '' : 'none';
    trigger.setAttribute('aria-expanded', String(open));
    chevron?.classList.toggle('-rotate-180', open);
    root.dataset.authAvatarOpen = open ? 'true' : 'false';
}

function initAuthenticatedUserAvatar(root) {
    if (root.dataset.authAvatarInitialized) return;
    root.dataset.authAvatarInitialized = 'true';

    const userName = root.dataset.userName || 'User';
    const color = getAvatarColor(userName);
    root.querySelectorAll('[data-auth-avatar-initials]').forEach(el => {
        el.textContent = getInitials(userName);
        el.classList.add(color);
    });

    const trigger = root.querySelector('[data-auth-avatar-trigger]');
    trigger?.addEventListener('click', event => {
        event.preventDefault();
        const open = root.dataset.authAvatarOpen !== 'true';
        document.querySelectorAll('[data-auth-avatar][data-auth-avatar-open="true"]').forEach(other => {
            if (other !== root) setOpen(other, false);
        });
        setOpen(root, open);
    });
}

function initAuthenticatedUserAvatars(scope = document) {
    scope.querySelectorAll?.('[data-auth-avatar]').forEach(initAuthenticatedUserAvatar);
}

function setLogoutLoading(form, loading) {
    const button = form.querySelector('[data-auth-avatar-logout-button]');
    const idle = form.querySelector('[data-auth-avatar-logout-idle]');
    const loadingEl = form.querySelector('[data-auth-avatar-logout-loading]');
    button && (button.disabled = loading);
    idle?.classList.toggle('hidden', loading);
    idle?.classList.toggle('flex', !loading);
    loadingEl?.classList.toggle('hidden', !loading);
    loadingEl?.classList.toggle('flex', loading);
}

if (!window.__authenticatedUserAvatarInitialized) {
    window.__authenticatedUserAvatarInitialized = true;

    document.addEventListener('click', event => {
        if (event.target.closest('[data-auth-avatar]')) return;
        document.querySelectorAll('[data-auth-avatar][data-auth-avatar-open="true"]').forEach(root => setOpen(root, false));
    });

    document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-auth-avatar][data-auth-avatar-open="true"]').forEach(root => setOpen(root, false));
    });

    document.body.addEventListener('submit', event => {
        const form = event.target;
        if (form?.matches?.('[data-auth-avatar-logout]')) setLogoutLoading(form, true);
    }, true);

    document.body.addEventListener('htmx:afterRequest', event => {
        const form = event.detail?.elt;
        if (!form?.matches?.('[data-auth-avatar-logout]')) return;
        setLogoutLoading(form, false);

        if (!event.detail.successful) {
            console.error('Logout request failed');
            return;
        }

        let response;
        try {
            response = JSON.parse(event.detail.xhr.responseText);
        } catch (error) {
            console.error('Error parsing logout response:', error);
            return;
        }

        if (!response.data || response.data.success != 1) {
            console.warn('Logout response:', response.message || 'Unknown error');
        }
        window.location.reload();
    });

    document.addEventListener('htmx:afterSwap', event => initAuthenticatedUserAvatars(event.target));
    document.addEventListener('htmx:oobAfterSwap', event => initAuthenticatedUserAvatars(event.target));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAuthenticatedUserAvatars());
} else {
    initAuthenticatedUserAvatars();
}
